import { SVGProps, useId } from "react";

export default function TargetIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M9.99707 2.16675C14.3232 2.16675 17.8309 5.67367 17.8311 9.99976C17.8311 14.326 14.3233 17.8337 9.99707 17.8337C5.67099 17.8336 2.16406 14.3259 2.16406 9.99976C2.16424 5.67378 5.6711 2.16692 9.99707 2.16675Z"
        stroke={`url(#paint0_${id})`}
      />
      <path
        d="M9.99707 4.04175C13.2792 4.04175 15.9559 6.71771 15.9561 9.99976C15.9561 13.2819 13.2793 15.9587 9.99707 15.9587C6.71503 15.9586 4.03906 13.2818 4.03906 9.99976C4.03915 9.96971 4.0516 9.93839 4.07715 9.91284C4.10276 9.88731 4.13398 9.87476 4.16406 9.87476C4.19415 9.87476 4.22536 9.88731 4.25098 9.91284C4.27653 9.93839 4.28897 9.96971 4.28906 9.99976C4.28906 13.1508 6.84608 15.7086 9.99707 15.7087C13.1482 15.7087 15.7061 13.1509 15.7061 9.99976C15.7059 6.84876 13.1481 4.29175 9.99707 4.29175C9.96702 4.29166 9.93571 4.27921 9.91016 4.25366C9.88462 4.22805 9.87207 4.19683 9.87207 4.16675C9.87207 4.13666 9.88462 4.10545 9.91016 4.07983C9.93571 4.05428 9.96702 4.04184 9.99707 4.04175Z"
        stroke={`url(#paint1_${id})`}
      />
      <path
        d="M10 6.54175C11.9071 6.54175 13.4578 8.09271 13.458 9.99976C13.458 11.9069 11.9072 13.4587 10 13.4587C9.96992 13.4587 9.9387 13.4462 9.91309 13.4207C9.88753 13.3951 9.87509 13.3638 9.875 13.3337C9.875 13.3037 9.88755 13.2724 9.91309 13.2468C9.93873 13.2212 9.96985 13.2087 10 13.2087C11.7678 13.2087 13.208 11.7676 13.208 9.99976C13.2078 8.2321 11.7677 6.79175 10 6.79175C9.96985 6.79175 9.93873 6.77931 9.91309 6.75366C9.88744 6.72802 9.875 6.6969 9.875 6.66675C9.875 6.6366 9.88744 6.60548 9.91309 6.57983C9.93873 6.55419 9.96985 6.54175 10 6.54175Z"
        stroke={`url(#paint2_${id})`}
      />
      <defs>
        <linearGradient
          id={`paint0_${id}`}
          x1="9.9974"
          y1="1.66675"
          x2="9.9974"
          y2="18.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_${id}`}
          x1="9.9974"
          y1="3.54175"
          x2="9.9974"
          y2="16.4584"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_${id}`}
          x1="11.6667"
          y1="6.04175"
          x2="11.6667"
          y2="13.9584"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}